import CommonRoutes from "./routes/CommonRoutes";

function App() {
  return <CommonRoutes />;
}

export default App;
